<div class="header">
    <div class="icon-site"></div>
    <div class="label">{{ getTitle() }}</div>
    <div class="icon-close" (click)="closeDialog()"></div>
</div>
<div class="container">
    <div class="name">Nom</div>
    <input class="name-input" type="text" placeholder="Nom du site" [(ngModel)]="site.name" />
    <ng-container *ngIf="!site.id">
        <div class="corporation">Entreprise</div>
        Est une entreprise :
        <input type="checkbox" [(ngModel)]="site.isCorporation" />
    </ng-container>
    <div class="main-container">
        <div class="left-column">
            <div class="filters">
                <div class="title">Utilisateurs à ajouter</div>
                <div class="search-container">
                    <input
                        type="search"
                        class="search"
                        [(ngModel)]="potentialUsersSearch"
                        placeholder="Chercher"
                        (keyup.enter)="searchPotentialUsers()"
                    />
                    <span class="icon-search" (click)="searchPotentialUsers()"></span>
                </div>
            </div>
            <div
                class="users-container"
                infiniteScroll
                [infiniteScrollDistance]="1"
                [infiniteScrollThrottle]="50"
                [scrollWindow]="false"
                (scrolled)="nextPage()"
            >
                <div
                    class="user"
                    *ngFor="let user of potentialUsers"
                    [ngClass]="{
                        disabled: !user.enabled
                    }"
                >
                    <div class="user-info">
                        <div class="icon" [ngClass]="getUserIcon(user)"></div>
                        <div class="label">
                            {{ user.lastname.toUpperCase() }}
                            {{ user.firstname }}
                        </div>
                    </div>
                    <div class="icon-NoterPlus" (click)="addUserToSite(user)"></div>
                </div>
            </div>
        </div>
        <div class="right-column">
            <div class="filters">
                <div class="title">
                    Utilisateurs du site<span class="group-count"
                        >({{ getSiteMembersCount() }})</span
                    >
                </div>
                <div class="search-container">
                    <input
                        type="search"
                        class="search"
                        [(ngModel)]="memberUsersSearch"
                        placeholder="Chercher"
                    />
                    <span class="icon-search"></span>
                </div>
            </div>
            <div class="users-container">
                <div class="user" *ngFor="let user of site.users | usersFilter: memberUsersSearch">
                    <div class="user-info">
                        <div class="icon" [ngClass]="getUserIcon(user)"></div>
                        <div class="label">
                            {{ user.lastname.toUpperCase() }}
                            {{ user.firstname }}
                        </div>
                    </div>
                    <div class="icon-NoterMoins" (click)="removeUserFromSite(user)"></div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="footer">
    <div
        class="create-button"
        [ngClass]="{
            disabled: !site.name
        }"
        (click)="createSite()"
    >
        Enregistrer
    </div>
</div>
